import lodash from "lodash-es";
import $ from "jquery";
import type { RouteMeta, RouteRecordRaw } from "vue-router";
import type { TreeNodeType } from "./menu";
import Clipboard from "clipboard";
import { ElMessageBox } from "element-plus";
// 通过角色菜单过滤出对应的路由信息，判断条件如果子级符合条件父级也应该符合条件
export type OtherRouteConf = {
  meta?: RouteMeta;
  title?: string;
  pageTitle?: string;
};
export type RouteConf = OtherRouteConf & RouteRecordRaw;
export function filterRoute(
  routes: RouteConf[],
  pagesCodeMap: Record<string | number, TreeNodeType>,
  pageRouteCodeMap: Record<string | number, TreeNodeType> = {},
  parentPath = ""
): RouteConf[] {
  const res: RouteConf[] = [];

  routes.map((o: RouteConf) => {
    if (o.children && o.children.length) {
      const childRoutes: RouteConf[] = filterRoute(
        o.children,
        pagesCodeMap,
        pageRouteCodeMap,
        parentPath + "/" + o.path
      );
      if (childRoutes.length) {
        const setItem = lodash.cloneDeep(o);
        setItem.children = childRoutes;
        res.push(setItem);
      }
    } else if (o.meta && o.meta.code && pagesCodeMap[o.meta.code as string]) {
      const keyCode: string = o.meta.code as string;
      pageRouteCodeMap[pagesCodeMap[keyCode].id] = pagesCodeMap[keyCode];
      pageRouteCodeMap[pagesCodeMap[keyCode].id].frontPath = (
        parentPath +
        "/" +
        o.path
      ).replace(/\/{2}/g, "/");
      const setItem = lodash.cloneDeep(o);
      if (setItem.meta && !setItem.meta.title) {
        setItem.meta.title = pagesCodeMap[keyCode].label;
      }
      if (setItem.meta && !setItem.meta.pageTitle) {
        setItem.meta.pageTitle =
          (pagesCodeMap[keyCode].parentLabel
            ? pagesCodeMap[keyCode].parentLabel + "-"
            : "") + setItem.meta.title;
      }
      res.push(setItem);
    }
  });
  return res;
}

export function moveIdx(list: any[], move: number, idx: number): void {
  if ((move == 1 && idx >= list.length - 1) || (move == -1 && idx <= 0)) {
    return;
  }
  const moveItem: any = list[idx];
  list.splice(idx, 1);
  list.splice(idx + move, 0, moveItem);
}

export function closeNowRouteTab(): void {
  $(
    ".el-tabs--card > .el-tabs__header .el-tabs__item.is-active.is-closable .el-icon-close"
  ).trigger("click");
}

export function toFixed2(num: number): number {
  return Math.ceil(num * 100) / 100;
}

export function openWin(url) {
  var a: any = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("id", "openWinLink");
  a.setAttribute("target", "_blank");
  // 防止反复添加
  let el: any = document.getElementById("openWinLink");
  if (el) {
    document.body.removeChild(el);
  }
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    a.remove();
  }, 500);
}
export function copyText(text: string, container?: any): Promise<any> {
  const VueClipboardConfig = {
    autoSetContainer: false,
    appendToBody: true, // This fixes IE, see #50
  };
  return new Promise(function (resolve, reject) {
    const fakeElement = document.createElement("button");
    const clipboard = new Clipboard(fakeElement, {
      text: function () {
        return text;
      },
      action: function () {
        return "copy";
      },
      container: typeof container === "object" ? container : document.body,
    });
    clipboard.on("success", function (e) {
      clipboard.destroy();
      resolve(e);
    });
    clipboard.on("error", function (e) {
      clipboard.destroy();
      reject(e);
    });
    if (VueClipboardConfig.appendToBody) document.body.appendChild(fakeElement);
    fakeElement.click();
    if (VueClipboardConfig.appendToBody) document.body.removeChild(fakeElement);
  });
}

/**
 *   遍历选项回选中文名称
 * @param {Array} data   选项数据
 * @param {string} val  选项值
 * @param {string} labelKey==label  匹配中文的key
 * @param {string} key==value  比对的key
 * @return {String}
 */
export function getLabel(
  data: any[],
  val: any,
  labelKey = "label",
  key = "value"
): string | any {
  let res = val;
  data.map((o: any) => {
    if (o[key] == val) {
      res = o[labelKey];
    }
  });
  return res;
}

/**
 * 判断文件加载失败提示更新刷新
 * @param {(Object)} err
 */
export function loadPageFaithCatch(err: any): void {
  console.log(err);
  if (!window.sessionStorage.getItem("hiddenRefreshTip")) {
    ElMessageBox.confirm(
      typeof window.navigator.onLine == "boolean" && !window.navigator.onLine
        ? "检测到您网络已断线,请恢复网络连接再尝试"
        : "当前系统已更新，请您按确定重新刷新页面，按取消则停留在当前页面不在显示提示",
      "警告",
      {
        confirmButtonText: "确定,刷新",
        cancelButtonText: "取消,不在显示提示",
        type: "warning",
      }
    )
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        window.sessionStorage.setItem("hiddenRefreshTip", "1");
        console.log("----");
      });
  }
}


export function postAllParentMessage(msg:any) {
  if (typeof top != "undefined" && !!top&&top!=parent) {
    top.postMessage(msg, "*");
  }
  if (typeof parent != "undefined" && !!parent) {
    parent.postMessage(msg, "*");
  }
}
